import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/specialEquipment',
    meta: { title: '特种设备管理' },
    component: Layout,
    redirect: '/specialEquipment/list',
    children: [
      {
        path: 'list',
        meta: { title: '特种设备管理', activeMenu: '/specialEquipment' },
        component: () => import('@/views/specialEquipment/SpecialEquipment.vue')
      },
      {
        path: 'detail',
        meta: { title: '特种设备详情', activeMenu: '/specialEquipment' },
        component: () => import('@/views/specialEquipment/SpecialEquipmentDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增特种设备', activeMenu: '/specialEquipment' },
        component: () => import('@/views/specialEquipment/SpecialEquipmentAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑特种设备', activeMenu: '/specialEquipment' },
        component: () => import('@/views/specialEquipment/SpecialEquipmentAdd.vue')
      }

    ]
  }

]
